function load() {
	const baseUrl = document.currentScript.src.slice(0, document.currentScript.src.lastIndexOf('/')),
		script = document.createElement('script');

	script.src = `${baseUrl}/advert-debug.js`;
	script.async = true;
	script.onload = () => {
		setTimeout(() => window.advert.debug.start(), 0);
	};

	document.body.appendChild(script);
}

module.exports = {
	load
};
